import lazyLoading from './lazyLoading'

export default {
  name: 'aircabReport',
  meta: {
    expanded: false,
    title: 'Reportes Aircab',
    iconClass: 'vuestic-icon vuestic-icon-statistics'
  },
  children: [
    {
      name: 'aircabReportTravels',
      path: '/aircab-report/travels',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Reporte Viajes'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('aircabReport/TravelList'),
          meta: {
            title: 'Reporte Viajes'
          }
        },
      ]
    },
    {
      name: 'aircabReportClients',
      path: '/aircab-report/clients',
      component: lazyLoading('config/Main'),
      meta: {
        title: 'Reporte Clientes'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('aircabReport/ClientList'),
          meta: {
            title: 'Reporte Clientes'
          }
        },
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/aircabReport.js